import { actions as refreshCounterActions } from '../reducers/refreshCounter';
import { actions as dashboardVariantActions } from '../reducers/dashboardVariant';
import { actions as userActions } from '../reducers/user';
import { actions as dashboardTabActions } from '../reducers/dashboardTab';
import eventEmitterThunk from './eventEmitterAction';

const allActions = {
    refreshCounterActions,
    dashboardVariantActions,
    userActions,
    dashboardTabActions,
    eventEmitterActions: { eventEmitterThunk }
};

export default allActions;